import { Box, Card, Typography, Button } from '@mui/material';
import { Hourglass } from 'lucide-react';
import { useSignOut } from '@lingaai/shared-hooks';
import { useNavigate } from 'react-router-dom';

export function PendingApproval() {
  const signOut = useSignOut();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut.mutateAsync();
      navigate('/login');
    } catch (err) {
      console.error('Sign out failed:', err);
    }
  };

  return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" bgcolor="grey.100">
      <Card sx={{ p: 4, maxWidth: 500, width: '100%', textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <Hourglass size={64} strokeWidth={1} color="#ed6c02" />
        </Box>

        <Typography variant="h4" gutterBottom>
          Pending Approval
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          Your account has been created successfully, but your organization administrator must approve your access before you can proceed.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          An email has been sent to your organization's administrators. You will receive a notification once your account has been approved.
        </Typography>

        <Button variant="outlined" onClick={handleSignOut} fullWidth>
          Sign Out
        </Button>
      </Card>
    </Box>
  );
}
